module.exports = __webpack_public_path__ + "img/icon_temperature.9c58644b.svg";